import { render, staticRenderFns } from "./SortOrderBy.vue?vue&type=template&id=5c3d9161&scoped=true&"
import script from "./SortOrderBy.vue?vue&type=script&lang=js&"
export * from "./SortOrderBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d9161",
  null
  
)

export default component.exports